'use strict';

var util = require('../../util/property-util');
var zabbixUtil = require('../pages/alarm/zabbix-util');


module.exports = /*@ngInject*/ ["$rootScope", "$scope", "GoogleMapsFactory", "DetailWindowFactory", "InvestigateStateChangeFactory", 
function MapMonitoringViewController(
    $rootScope,
    $scope, 
    GoogleMapsFactory, 
    DetailWindowFactory, 
    InvestigateStateChangeFactory) {

    var vm = this;

    console.log(vm)
    vm.map = undefined;
    vm.markers = [];
    vm.bounds;

    var hasFitBounds = false;

    var deRegisterTrainsUpdatedListener = $rootScope.$on('trains-updated', function(){
        getTrainsData();
    });

    init();

    $scope.$watch("vm.trains", function(newValue){
        vm.trains = newValue;
        hasFitBounds = false;
        init();
    });


    /*
     FUNCTIONS
     */

    function getTrainsData() {
        if (vm.trains && vm.map) {
            vm.markers = preprocessTrainsForMapDisplay(vm.trains);
            if (vm.markers && vm.markers.length > 0 && !hasFitBounds) {
                vm.map.fitBounds(vm.bounds);
                hasFitBounds = true;
            }
            vm.map.set('disableDoubleClickZoom', true);
        }
    }

    function init() {
        if (vm.trains && vm.trains.length > 0) {
            if (!util.isDefined(vm.map)) {
                drawMap().then(function() {
                    getTrainsData();
                });
            } 
        }
        getTrainsData();
    }

    function drawMap() {
        return new Promise(function(resolve, reject){
            var mapPromise = GoogleMapsFactory.createMap('trainmap');
            var mapOptions = {
                zoomControl: true,
                panControl: false,
                rotateControl: false,
                scaleControl: false,
                streetViewControl: false
            };
            mapPromise.then(function (data) {
                data.setOptions(mapOptions);
                vm.map = data;
                resolve();
            }).catch(function(err) {
                reject(err);
            });
        });
        
    }

    function preprocessTrainsForMapDisplay(trains) {
        if(vm.markers) {            
            vm.markers.forEach(function(marker) {
                 marker && marker.setMap(null);
            });
         }
        vm.bounds =  new google.maps.LatLngBounds();
        return trains.map(function(train){
            var trainPosition = train.currentPosition;
            if (trainPosition && (trainPosition.latitude !== 0) && (trainPosition.longitude !== 0)) {
                var markerColor = train.alarmAckStyle && train.alarmAckStyle['background-color'] || 'lime';
                var fontColor = train.alarmAckStyle && train.alarmAckStyle['color'] || 'black';
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(trainPosition.latitude, trainPosition.longitude),
                    map: vm.map,
                    title: 'Train: ' + train.name,
                    icon: new google.maps.MarkerImage(
                        zabbixUtil.createCustomMarker(markerColor, fontColor, train.name),
                        new google.maps.Size(32, 42),
                        null,
                        null,
                        new google.maps.Size(32, 42)
                    )
                });
                marker.projectId = train.projectId;
                marker.trainId = train.trainId;
                marker.officialId = Number(train.officialId);
                vm.bounds.extend(marker.getPosition());
                google.maps.event.addListener(marker, 'click', function () {
                    InvestigateStateChangeFactory.investigateInDetail(train);
                });
                google.maps.event.addListener(marker, 'rightclick', function () {
                    DetailWindowFactory.openModal(train, function (train) {
                        InvestigateStateChangeFactory.investigateInDetail(train);
                    }, function () {
                    });
                });
                google.maps.event.addListener(marker, 'mouseover', function () {
                    $scope.$emit('information-tooltip');
                });
                return marker;
            } else {
                return null;
            }
        });
    }

    $scope.$on('$destroy', function () {
        console.log("destrying map")
        deRegisterTrainsUpdatedListener();
        vm.map = undefined;
        vm.markers = [];
        vm.bounds;
    });

}];